<template>
  <div class="print-container">
    <!-- FIX: Replaced 'no-print' with Vuetify's 'd-print-none' to beat the d-flex !important rule -->
    <div class="d-print-none d-flex justify-center mb-6 mt-6">
      <v-btn color="primary" x-large @click="printPage">
        <v-icon left>mdi-printer</v-icon> Print QR Poster
      </v-btn>
    </div>

    <!-- MAIN POSTER -->
    <v-card class="poster-card elevation-0 text-center mx-auto mb-10" max-width="800">
    <div class="poster-background">
        <img
        v-if="mitId && !imageError"
        :src="`/images/qr_${mitId}.png`"
        @error="imageError = true"
        alt="QR Code"
        class="qr-overlay"
        />
        
        <!-- NEW: Location Name Label underneath the main QR code -->
        <div v-if="mitId && !imageError && locationName" class="qr-name-overlay font-weight-bold">
            {{ locationName }}
        </div>

        <div v-if="imageError" class="qr-error error--text text-h6">
            <v-icon large color="error" class="mb-2">mdi-alert-circle</v-icon><br>
            QR Image not found.<br>
            <span class="text-body-2">Ensure it was generated on the map editor.</span>
        </div>
    </div>
    </v-card>

    <v-divider class="my-10 d-print-none"></v-divider>

    <!-- MINI QR CODES -->
    <div class="mini-qrs-container d-flex justify-center flex-wrap mx-auto pb-10" style="gap: 40px; max-width: 800px;">
            
    <!-- White Mini QR -->
    <v-card class="mini-qr-card white-bg pa-4 text-center elevation-2">
        <h3 class="text-h5 font-weight-bold mb-2 black--text">Directions</h3>
        <img
        v-if="mitId && !imageError"
        :src="`/images/qr_${mitId}.png`"
        alt="QR Code"
        class="mini-qr-image"
        />
        <!-- NEW: Mini label -->
        <div class="text-caption mt-0 font-weight-bold black--text" style="padding-top: 0;">{{ locationName }}</div>
        <div class="text-caption mt-1 grey--text text--darken-1">Developed by CSAIL TIG</div>
    </v-card>

    <!-- Black Mini QR -->
    <v-card class="mini-qr-card black-bg pa-4 text-center elevation-2" dark color="black">
        <h3 class="text-h5 font-weight-bold mb-2 white--text">Directions</h3>
        <img
        v-if="mitId && !imageError"
        :src="`/images/qr_${mitId}.png`"
        alt="QR Code"
        class="mini-qr-image qr-white-backing"
        />
        <!-- NEW: Mini label -->
        <div class="text-caption mt-1 font-weight-bold white--text">{{ locationName }}</div>
        <div class="text-caption mt-1 grey--text text--lighten-1">Developed by CSAIL TIG</div>
    </v-card>
    </div>


    <!-- Debug Link -->
    <div class="d-print-none text-center mt-8 px-4 pb-10" v-if="targetUrl">
      <div class="text-subtitle-1 grey--text text--darken-2 font-weight-bold mb-1">
        <v-icon small left color="grey darken-2">mdi-bug</v-icon> Debug QR Link
      </div>
      <a :href="targetUrl" target="_blank" class="text-body-1 text-decoration-none primary--text">
        {{ targetUrl }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MitPrintQrPage',
  data() {
    return {
      mitId: null,
      locationName: 'Navigation Point',
      imageError: false
    }
  },
  computed: {
    targetUrl() {
      if (!this.mitId) return '';
      return `${window.location.origin}/directions?qr=${this.mitId}`;
    }
  },
  mounted() {
    this.mitId = this.$route.query.id;
    if (this.$route.query.name) {
      this.locationName = this.$route.query.name;
    }
  },
  methods: {
    printPage() {
      window.print();
    }
  }
}
</script>

<style scoped>
.qr-name-overlay {
  position: absolute;
  top: 48%;
  left: 50%;
  /* Aligns X perfectly with the image, pushes Y exactly below the 200px box */
  transform: translate(-150%, calc(-5% + 205px)); 
  width: 200px;
  text-align: center;
  font-size: 12px;
  color: #000;
  /*padding: 2px;*/
  border-radius: 4px;
}
.print-container {
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* Main Poster Styles */
.poster-card {
  background: white;
  border: 4px solid #1976D2;
  border-radius: 20px !important;
  overflow: hidden;
}

.poster-background {
  position: relative;
  width: 100%;
  height: 900px; 
  background-image: url('/assets/lobby-qr-code-poster.png');
  background-size: contain; /* FIX: Changed from cover to contain to stop cropping */
  background-position: center;
  background-repeat: no-repeat;
}

.qr-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-150%, -5%);
  width: 200px;
  height: 200px;
  
  background-color: white;
  border: 8px solid #ffffff;
  border-radius: 12px;
  /* box-shadow: 0 10px 30px rgba(0,0,0,0.2); */
  /* The magic trick to make the white background of the image transparent */
  mix-blend-mode: multiply;
  
  /* Remove the solid white styling to allow it to blend seamlessly */
  background-color: transparent;
  border: none;
  box-shadow: none;
}

.qr-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255,255,255,0.95);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* Mini QR Styles */
.mini-qr-card {
  width: 260px;
  border: 2px solid #ccc;
  border-radius: 12px !important;
}

.mini-qr-image {
  width: 180px;
  height: 180px;
  object-fit: contain;
}

.black-bg {
  background-color: #121212 !important;
  border-color: #333;
}

.qr-white-backing {
  background-color: white;
  padding: 8px;
  border-radius: 8px;
}

@media print {
  @page {
    margin: 0.5in;
  }
  body { 
    background: white !important; 
  }
  
  .print-container { 
    background-color: white; 
    padding: 0; 
  }
  
  .poster-card {
    border: none !important; 
    box-shadow: none !important;
    max-width: 100% !important;
    width: 100%;
  }

  .poster-background, .black-bg {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .mini-qrs-container {
    page-break-before: always;
  }
}
</style>